// extracted by mini-css-extract-plugin
export default {"container":"zoom-level_container__GZ2qU plainBackgroundColor"};